<div class="d-flex flex-column gap-5">
  <div class="card">
    <div class="card-body p-5">
      <div class="d-flex align-items-center">
        <div class="h1 flex-grow-1 mb-0">
          Adjustments
        </div>

        @if (isHarbourDuesAdvisor()) {
          <button
            type="button"
            class="btn btn-outline-primary btn-sm"
            (click)="onClick()">
            <i class="fa fa-plus"></i> Add one-off invoice adjustment
          </button>
        }
      </div>

      @if (showIncidentals()) {
        <app-harbour-dues-rotterdam-incidental
          [harbourDuesDetails]="harbourDuesDetails()"
          [isHarbourDuesAdvisor]="isHarbourDuesAdvisor()">
        </app-harbour-dues-rotterdam-incidental>
      }

      <app-form-field label="Choose what applies" [includeMargin]="false">
        <app-radio
          [options]="[DiscountSelection.NO_DISCOUNT, DiscountSelection.DISCOUNT, DiscountSelection.SPECIAL_FEE, DiscountSelection.EXEMPTION]"
          [formControl]="selectedType" [formatter]="formatSelectionType" [inline]="true" required></app-radio>
      </app-form-field>
      @switch (selectedTypeValue()) {
        @case (DiscountSelection.DISCOUNT) {
          <app-harbour-dues-discount [harbourDuesDetails]="harbourDuesDetails()"></app-harbour-dues-discount>
        }
        @case (DiscountSelection.SPECIAL_FEE) {
          <app-harbour-dues-special-tariff [harbourDuesDetails]="harbourDuesDetails()"></app-harbour-dues-special-tariff>
        }
        @case (DiscountSelection.EXEMPTION) {
          <app-harbour-dues-exemption [harbourDuesDetails]="harbourDuesDetails()"></app-harbour-dues-exemption>
        }
      }
    </div>
  </div>
</div>

